import { Controller } from 'stimulus';

// Redirecting within a turbo visit causes the anchor string to be stripped
// (see - https://github.com/hotwired/turbo/issues/211)

// Instead we can use a `turbo_anchor` param in the same way and this
// controller will handle scrolling to the element
export default class extends Controller {
  connect() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const turboAnchor = urlParams.get('turbo_anchor');

    if (turboAnchor?.length) {
      const targetEl = document.getElementById(turboAnchor);

      if (!targetEl) return;

      // A Tabulator group header sits in a hidden container until the table
      // has built and moved it into its group row.
      if (!targetEl.getClientRects().length) {
        this.onTableBuilt = () => this.scrollTo(targetEl);
        document.addEventListener('tabulator-table:built', this.onTableBuilt, {
          once: true,
        });
      } else {
        // Skip a frame to allow the template to be rendered
        requestAnimationFrame(() => this.scrollTo(targetEl));
      }
    }
  }

  disconnect() {
    if (this.onTableBuilt) {
      document.removeEventListener('tabulator-table:built', this.onTableBuilt);
      this.onTableBuilt = null;
    }
  }

  // `scrollIntoView` also scrolls the Tabulator's horizontal scroller when the
  // target is wider than it, hiding the first columns; keep it where it was.
  scrollTo(targetEl) {
    const holder = targetEl.closest('.tabulator-tableholder');
    const scrollLeft = holder?.scrollLeft;

    targetEl.scrollIntoView();

    if (holder) holder.scrollLeft = scrollLeft;
  }
}
